import { Observable } from "rxjs/Observable";
import * as actions from "./lookup-type.actions";
import { LookupType } from "./lookup-type.model";
import { CategoryStoreFacade } from "../category/category.store-facade";
import { ActionOptionsArgs } from "../../../core/store/actions/base-actions";
import { Qry } from "../query-facade";

export class LookupTypeStoreFacade extends CategoryStoreFacade<LookupType> {

    get(id: string): Observable<LookupType> {
        return this.select(Qry.getInstance().lookupType.byId(id));
    }

    getAll(): Observable<Array<LookupType>> {
        return this.select(Qry.getInstance().lookupType.byActiveAccount);
    }

    getForAllAccounts(): Observable<Array<LookupType>> {
        return this.select(Qry.getInstance().lookupType.items);
    }

    getFiltered(): Observable<Array<LookupType>> {
        return this.select(Qry.getInstance().lookupType.filtered);
    }

    create(lookupType: LookupType): void {
        this.dispatch(new actions.SubmitAction(lookupType));

        this.appFacade.objects.membership.store.getActive().take(1).subscribe(membership => {
            this.appFacade.objects.membership.store.attachLookupType(membership, lookupType, {restful: false, persistable: true});
        });

        this.appFacade.objects.membership.store.enqueueRefresh();
    }

    update(lookupType: LookupType): void {
        this.dispatch(new actions.SubmitAction(lookupType));
    }

    insert(lookupType: LookupType): void {
        this.dispatch(new actions.SubmitAction(lookupType, {persistable: true, restful: false}));
    }

    remove(lookupType: LookupType, options?: ActionOptionsArgs): void {

        this.appFacade.objects.lookup.store.removeByLookupType(lookupType, options);

        this.appFacade.objects.membership.store.getActive().take(1).subscribe(membership => {
            this.appFacade.objects.membership.store.detachLookupType(membership, lookupType, {restful: false, persistable: true});
        });

        this.dispatch(new actions.RemoveAction(lookupType, options));

        this.appFacade.objects.membership.store.enqueueRefresh();
    }

    setFilter(filters): void {
        this.dispatch(new actions.SetFilterAction(filters));
    }

    canDelete(lookupType: LookupType): Observable<boolean> {
        return this.checkHasDependency(this.appFacade.objects.lookup.store, lookupType, "Lookup")
            .switchMap(() => super.canDelete(lookupType));
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/lookup-type/lookup-type.store-facade.ts